import {
  CalendarRange,
  FolderKanban,
  ListChecks,
  Users,
  Building2,
  BarChart3,
} from 'lucide-react';
import type { MessageSquare } from 'lucide-react';

export type TaskNavChild = {
  to: string;
  label: string;
  Icon: typeof MessageSquare;
};

/**
 * The Task Management section's sub-navigation. Shared by:
 *  - AppSidebar (the fixed icon rail) — for the Tasks icon's default target and
 *    access-visibility (the icon shows when at least one child is visible).
 *  - TaskNavPanel (the secondary list panel) — renders these as the list that
 *    opens beside the rail, mirroring how the Chat conversation list opens.
 */
export const TASK_NAV_CHILDREN: TaskNavChild[] = [
  { to: '/todo', label: 'Daily Planner', Icon: CalendarRange },
  { to: '/projects', label: 'Projects', Icon: FolderKanban },
  { to: '/tasks/list', label: 'Tasks', Icon: ListChecks },
  { to: '/clients', label: 'Clients', Icon: Users },
  { to: '/vendors', label: 'Vendors', Icon: Building2 },
  { to: '/tasks/reports', label: 'Reports', Icon: BarChart3 },
];

const LIMITED_TASK_PATHS = new Set(['/todo', '/tasks/list']);

export const taskNavForWorkspace = (limited: boolean): TaskNavChild[] =>
  limited
    ? TASK_NAV_CHILDREN.filter((item) => LIMITED_TASK_PATHS.has(item.to))
    : TASK_NAV_CHILDREN;

/**
 * Route prefixes that belong to the Task Management section. The Tasks icon in
 * the rail is highlighted, and the TaskNavPanel is shown, while the user is on
 * any of these routes.
 */
export const TASK_ROUTE_PREFIXES = ['/todo', '/projects', '/tasks', '/clients', '/vendors'];

export const isTaskRoute = (pathname: string): boolean =>
  TASK_ROUTE_PREFIXES.some((p) => pathname.startsWith(p));
